var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section__acceleration"},[_c('div',{staticClass:"section__wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }